import React, { useState } from "react";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";
import { Filter, X } from "react-feather";

/**
 * SitesFilter - Filter component for sites view
 */
const SitesFilter = ({ filters, onApplyFilters, onClearFilters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleChange = (field, value) => {
    setLocalFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleApply = () => {
    onApplyFilters(localFilters);
  };

  const handleClear = () => {
    const defaultFilters = {
      user: "",
      name: "",
      sortBy: "createdAt",
      sortDir: "desc",
    };
    setLocalFilters(defaultFilters);
    onClearFilters();
  };

  return (
    <div className="sites-filter mb-3 p-3 border rounded">
      <h6 className="mb-3">
        <Filter size={16} className="me-2" />
        Filters
      </h6>
      <Row>
        <Col md="3">
          <FormGroup>
            <Label for="filterUser">User</Label>
            <Input
              id="filterUser"
              type="text"
              placeholder="Search by user..."
              value={localFilters.user || ""}
              onChange={(e) => handleChange("user", e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <Label for="filterName">Site Name</Label>
            <Input
              id="filterName"
              type="text"
              placeholder="Search by name..."
              value={localFilters.name || ""}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <Label for="filterSortBy">Sort By</Label>
            <Input
              id="filterSortBy"
              type="select"
              value={localFilters.sortBy || "createdAt"}
              onChange={(e) => handleChange("sortBy", e.target.value)}
            >
              <option value="createdAt">Created At</option>
              <option value="updatedAt">Updated At</option>
              <option value="name">Name</option>
              <option value="id">ID</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <Label for="filterSortDir">Order</Label>
            <Input
              id="filterSortDir"
              type="select"
              value={localFilters.sortDir || "desc"}
              onChange={(e) => handleChange("sortDir", e.target.value)}
            >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex align-items-center gap-2">
          <Button
            color="primary"
            onClick={handleApply}
            title="Apply Filters"
          >
            <Filter size={14} className="me-1" />
            Apply
          </Button>
          <Button
            color="secondary"
            size="sm"
            outline
            onClick={handleClear}
          >
            <X size={14} className="me-1" />
            Clear Filters
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SitesFilter;
